<template>
  <button v-if="canGoBack" @click="goBack" class="back-button"><i class="fa fa-chevron-left"></i></button>
</template>

<script>
import {useIonRouter} from "@ionic/vue";

export default {
  name: "BackButton",
  mounted()
  {
    this.ionRouter = useIonRouter();
    this.canGoBack = this.ionRouter.canGoBack()
  },
  data()
  {
    return {
      canGoBack:false,
      ionRouter:null
    }
  },
  watch:{
    '$route.path': {
      handler()
      {
        const c = this.ionRouter.canGoBack();
        if (!this.canGoBack && c)
        {
          setTimeout(()=>{
            this.canGoBack = true
          },900)
        }
        else
        {
          this.canGoBack = c;
        }
      }
    }
  },
  methods:{
    goBack()
    {
      try
      {
        this.$router.back()
      }
      catch (e)
      {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>
.back-button {
  background: transparent;
  color: #fff;
  font-size: 15px;
  margin: 0 5px;
  transform: scale(1.5,1);
  padding:14px;
}
</style>